import { AppwriteException } from "appwrite";
import { AxiosError } from "axios";
import { ZodError } from "zod";
import {ZodAggregateAccountSum, AggregateAccountSum} from '@/types';
import errorsController from '@/utils/errorsController';
import {customInstanceAWS} from "@/http";

export const getAccountsSum = async (queryParams: AggregateAccountSum, displayToast = true) => {
	try {
		const { is_demo: isDemo, ...rest} = ZodAggregateAccountSum.parse(queryParams);
		const params: {[k in keyof AggregateAccountSum]: k extends 'is_demo' ? string | undefined : AggregateAccountSum[k]} = {
			...rest,
			...(isDemo !== undefined && {is_demo: isDemo.toString()})
		}

		return (await customInstanceAWS.get(`/aggregate/sum/account?${new URLSearchParams(params).toString()}`)).data
	} catch (error: AxiosError | AppwriteException | ZodError | Error | unknown) {
		if (error instanceof AxiosError || error instanceof AppwriteException || error instanceof ZodError || error instanceof Error) {
			return errorsController(error, displayToast);
		}
	}
}
